import { useQuery } from '@tanstack/react-query';

import { withGlobalError } from '@/react-tools/react-query';
import PortainerError from '@/portainer/error';

import { EnvironmentGroupId } from '../types';

import { EnvironmentGroup } from './types';
import { getGroup, getGroups } from './environment-groups.service';
import { queryKeys } from './queries/query-keys';

/** Get all environment groups. **Only portainer administrators can access this endpoint.** */
export function useGroups<T = EnvironmentGroup[]>({
  select,
  enabled = true,
  size = false,
}: {
  select?: (group: EnvironmentGroup[]) => T;
  enabled?: boolean;
  size?: boolean;
} = {}) {
  return useQuery(queryKeys.base(size), () => getGroups(size), {
    select,
    enabled,
  });
}

/** Get the environment group by id. **Only portainer administrators can access this endpoint.** */
export function useGroup<T = EnvironmentGroup>(
  groupId?: EnvironmentGroupId,
  {
    select,
    enabled = true,
  }: {
    select?: (group: EnvironmentGroup | null) => T;
    enabled?: boolean;
  } = {}
) {
  return useQuery<EnvironmentGroup | null, PortainerError, T>(
    queryKeys.group(groupId),
    () => {
      if (groupId === undefined) {
        return null;
      }
      return getGroup(groupId);
    },
    {
      staleTime: 50,
      select,
      enabled: enabled && groupId !== undefined,
      ...withGlobalError('Failed loading group'),
    }
  );
}
